const linkPrefix = (key) => {
    const match = /^(.*)\.(label|url)$/.exec(key);
    return match ? match[1] : null;
};
export const buildEventPageLayout = (fields) => {
    const sections = [];
    for (const field of fields) {
        let section = sections.find((s) => s.section === field.section);
        if (!section) {
            section = { section: field.section, cards: [] };
            sections.push(section);
        }
        if (field.type === 'Image') {
            section.cards.push({ kind: 'image', id: field.key, field });
            continue;
        }
        const prefix = linkPrefix(field.key);
        if (prefix) {
            let card = section.cards.find((c) => c.kind === 'link' && c.prefix === prefix);
            if (!card) {
                card = { kind: 'link', id: prefix, prefix };
                section.cards.push(card);
            }
            if (field.key.endsWith('.label'))
                card.label = field;
            else
                card.url = field;
            continue;
        }
        section.cards.push({ kind: 'text', id: field.key, field });
    }
    for (const section of sections) {
        section.cards.sort((a, b) => Number(b.kind === 'image') - Number(a.kind === 'image'));
    }
    return sections;
};
/** Consecutive button cards share a row (two per row on wider screens), like the design. */
export const groupLinkRows = (cards) => {
    const rows = [];
    for (const card of cards) {
        const last = rows[rows.length - 1];
        if (card.kind === 'link' && last && last[0].kind === 'link' && last.length < 2)
            last.push(card);
        else
            rows.push([card]);
    }
    return rows;
};
/** react-hook-form treats "." as nesting, so registry keys are stored with "__" instead. */
export const toFormKey = (key) => key.replace(/\./g, '__');
export const fromFormKey = (formKey) => formKey.replace(/__/g, '.');
export const flagSrcFor = (code, flagUrl) => {
    if (flagUrl)
        return flagUrl;
    const normalized = code.toLowerCase();
    const flagCode = normalized === 'en' ? 'us' : normalized === 'sv' ? 'se' : normalized;
    return `/assets/images/flags/${flagCode}-flag.svg`;
};
